module.exports = __webpack_public_path__ + "img/profile-background-grey.2fa10c83.png";